
define('include/mono', [
    'jquery',
    'marionette',
    'backbone.async.events',
    'marionette.slideview',
    'marionette.cycleview',
    'marionette.fitview',
    'marionette.ext',
    'jquery.idle-timer',
    'jquery.ajax-progress',
    'bootstrap/transition', 
    'bootstrap/collapse', 
    'bootstrap/dropdown'
]);
